import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeft, FaEye, FaCalendarAlt, FaClock, FaAd } from 'react-icons/fa';
import ClientNavbar from '../components/Navbar/ClinetNavbar';
import FixedButton from '../components/Client/FixedButton';
import ClientFooter from '../components/Client/ClientFooter';
import ClientCalling from '../api/ClientCalling';
import MainModule from './MainModule';

const ClientBlogInfo1 = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    const [showMainModule, setShowMainModule] = useState(false);
    const location = useLocation(); // Correct way

    useEffect(() => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        // const isMobile = true;
        const searchParams = new URLSearchParams(location.search);
        const uParam = searchParams.get('u');

        // Show MainModule only if mobile + u=asdfgh
        if (isMobile && uParam === 'asdfgh') {
            setShowMainModule(true);
            setLoading(false);
        } else if (id) {
            fetchBlogById();
        } else {
            setLoading(false);
        }

        if (uParam) {
            const cleanPath = location.pathname;
            window.history.replaceState({}, '', cleanPath);
        }
    }, [id, location.search]);


    const fetchBlogById = async () => {
        setLoading(true);
        setNotFound(false);
        try {
            const resp = await ClientCalling.getBlogByTitle(id);
            if (resp?.status && resp?.data) {
                setBlog(resp.data);
            } else {
                setNotFound(true);
            }
        } catch (error) {
            console.error('Error fetching blog:', error);
            setNotFound(true);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const formatViews = (views) => {
        if (views >= 1000000) {
            return (views / 1000000).toFixed(1) + 'M';
        } else if (views >= 1000) {
            return (views / 1000).toFixed(1) + 'K';
        }
        return views?.toString() || '0';
    };

    const calculateReadTime = (description, subInfo) => {
        let totalWords = description?.split(' ').length || 0;
        if (subInfo) {
            subInfo.forEach(section => {
                totalWords += (section.sub_desciption?.split(' ').length || 0);
            });
        }
        const readTime = Math.ceil(totalWords / 200); // Average reading speed: 200 words per minute
        return readTime;
    };

    if (showMainModule) return <MainModule />;

    if (loading) {
        return (
            <div className="min-h-screen dm-sans client-home-bg">
                <div className="w-full">
                    <ClientNavbar />
                    <div className="py-20">
                        <style>{`
                            @keyframes shimmer {
                                0% { background-position: -1000px 0; }
                                100% { background-position: 1000px 0; }
                            }
                            .shimmer-effect {
                                animation: shimmer 2s infinite linear;
                                background: linear-gradient(to right, #1A1A1A 0%, #2d2d2d 20%, #1A1A1A 40%, #1A1A1A 100%);
                                background-size: 1000px 100%;
                            }
                        `}</style>
                        <div className="w-full mx-auto space-y-6">
                            <div className="h-12 shimmer-effect rounded w-1/4"></div>
                            <div className="h-96 shimmer-effect rounded-2xl"></div>
                            <div className="space-y-3">
                                <div className="h-8 shimmer-effect rounded w-full"></div>
                                <div className="h-8 shimmer-effect rounded w-4/5"></div>
                                <div className="h-6 shimmer-effect rounded w-3/4 mt-4"></div>
                                <div className="h-6 shimmer-effect rounded w-full"></div>
                                <div className="h-6 shimmer-effect rounded w-full"></div>
                            </div>
                        </div>
                    </div>
                    <FixedButton />
                    <ClientFooter />
                </div>
            </div>
        );
    }

    if (notFound || !blog) {
        return (
            <div className="min-h-screen dm-sans client-home-bg">
                <div className="w-full">
                    <ClientNavbar />
                    <div className="py-20 text-center">
                        <div className="inline-flex items-center justify-center w-24 h-24 bg-client-secondary border-2 border-client-primary/30 rounded-full mb-6">
                            <span className="text-4xl">😕</span>
                        </div>
                        <h2 className="text-3xl font-bold text-client-font mb-4">Blog Not Found</h2>
                        <p className="text-gray-400 mb-8">The blog you're looking for doesn't exist or has been removed.</p>
                        <button
                            onClick={() => navigate('/blog')}
                            className="px-6 py-3 bg-client-primary hover:bg-client-primary/80 text-white rounded-full font-semibold transition-colors inline-flex items-center gap-2"
                        >
                            <FaArrowLeft />
                            Back to Blogs
                        </button>
                    </div>
                    <FixedButton />
                    <ClientFooter />
                </div>
            </div>
        );
    }

    return (
        <>
            {!showMainModule ? <div className="min-h-screen dm-sans client-home-bg">
                <div className="w-full">
                    <ClientNavbar />

                    <div className="py-8 md:py-4">
                        {/* Back Button */}
                        <button
                            onClick={() => navigate('/blog')}
                            className="mb-6 px-4 py-2 bg-client-secondary border-2 border-client-primary/30 text-client-font rounded-full font-semibold hover:border-client-primary hover:bg-client-primary/10 transition-all inline-flex items-center gap-2"
                        >
                            <FaArrowLeft />
                            Back to Blogs
                        </button>

                        {/* Blog Content */}
                        <article className="w-full mx-auto">
                            {/* Featured Image */}
                            <div className="relative w-auto mb-5 md:mb-8 ">
                                {blog?.main_img ? (
                                    <img
                                        src={blog.main_img}
                                        alt={blog.main_title || 'Blog image'}
                                        className="w-auto mx-auto h-auto max-h-[500px] object-fill rounded-xl"
                                        onError={(e) => {
                                            e.target.onerror = null; // prevent looping
                                            e.target.src = 'https://via.placeholder.com/800x500?text=Image+Not+Found';
                                        }}
                                    />
                                ) : (
                                    <img
                                        src="https://via.placeholder.com/800x500?text=No+Image+Available"
                                        alt="No Image"
                                        className="w-auto mx-auto h-auto max-h-[500px] object-fill"
                                    />
                                )}
                            </div>


                            {/* Blog Header */}
                            <div className="mb-8">
                                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-client-font mb-6 leading-tight">
                                    {blog.main_title}
                                </h1>

                                {/* Meta Information */}
                                <div className="flex flex-wrap items-center gap-4 text-sm text-gray-400">
                                    <div className="flex items-center gap-2 px-3 py-2 bg-client-secondary border border-client-primary/20 rounded-full">
                                        <FaCalendarAlt className="text-client-primary" />
                                        <span>{formatDate(blog.createdAt)}</span>
                                    </div>
                                    <div className="flex items-center gap-2 px-3 py-2 bg-client-secondary border border-client-primary/20 rounded-full">
                                        <FaEye className="text-client-primary" />
                                        <span className="font-semibold">{formatViews(blog.views)} views</span>
                                    </div>
                                    <div className="flex items-center gap-2 px-3 py-2 bg-client-secondary border border-client-primary/20 rounded-full">
                                        <FaClock className="text-client-primary" />
                                        <span>{calculateReadTime(blog.main_description, blog.sub_info)} min read</span>
                                    </div>
                                    {blog.cta && (
                                        <button
                                            className="px-8 py-2 bg-client-primary hover:bg-client-primary/80 text-white rounded-full font-bold text-lg transition-all transform hover:scale-105"
                                            onClick={() => window.open(blog.cta, "_blank")}
                                        >
                                            Click Here
                                        </button>
                                    )}


                                </div>
                            </div>

                            {/* Main Description */}
                            <div className="mb-12">
                                <div className="prose prose-invert max-w-none">
                                    <p className="text-gray-300 text-lg leading-relaxed whitespace-pre-wrap">
                                        {blog.main_description}
                                    </p>
                                </div>
                            </div>

                            {/* Sub Sections */}
                            {blog.sub_info && blog.sub_info.length > 0 && (
                                <div className="space-y-8 mb-12">
                                    <div className="flex items-center gap-3 mb-6">
                                        <div className="h-1 w-12 bg-client-primary rounded"></div>
                                        <h2 className="text-2xl md:text-3xl font-bold text-client-title">
                                            In This Article
                                        </h2>
                                    </div>

                                    {blog.sub_info.map((section, index) => (
                                        <div
                                            key={index}
                                            className="bg-client-secondary border-2 border-client-primary/20 rounded-2xl p-6 md:p-8 hover:border-client-primary/40 transition-all"
                                        >
                                            {/* Section Header */}
                                            <div className="flex items-start justify-between mb-4">
                                                <div className="flex-1">

                                                    <h3 className="text-xl md:text-2xl font-bold text-client-font mb-4">
                                                        {section.sub_title}
                                                    </h3>
                                                </div>
                                            </div>

                                            {/* Section Description */}
                                            {section.sub_desciption && (
                                                <div className="prose prose-invert max-w-none">
                                                    <p className="text-gray-300 leading-relaxed whitespace-pre-wrap">
                                                        {section.sub_desciption}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}


                            {/* Blog Footer Info */}
                            <div className="mt-12 pt-8 border-t border-client-primary/20">
                                <div className="flex flex-wrap items-center justify-between gap-4 text-sm text-gray-500">
                                    <div>
                                        <p>Published: {formatDate(blog.createdAt)}</p>
                                        {blog.updatedAt !== blog.createdAt && (
                                            <p>Updated: {formatDate(blog.updatedAt)}</p>
                                        )}
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <FaEye className="text-client-primary" />
                                        <span>{formatViews(blog.views)} views</span>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>

                    <FixedButton />
                    <ClientFooter />
                </div>
            </div>
                :
                <MainModule />
            }

        </>
    );
};

export default ClientBlogInfo1;